<template>
  <div class="container">
    <h3 class="text-center">Before we begin, please select your prefered ruleset.</h3>
    <h6 class="text-center c5">( You can change this later under user settings. )</h6>
    <br>
    <br>
    <div class="row justify-content-center">
      <div class="col-12 col-sm-6 text-center">
        <div
          class="row rule-select"
          :class="{ selected: ruleset === '5th Edition' }"
          @click="set('5th Edition')"
        >
          <div class="col-2 initials">
            <h2 class="dd">5e14</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Dungeons & Dragons</h2>
          </div>
        </div>

        <div
          class="row rule-select"
          :class="{ selected: ruleset === '5e 2024' }"
          @click="set('5e24')"
        >
          <div class="col-2 initials">
            <h2 class="dd">5e24</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Dungeons & Dragons</h2>
          </div>
        </div>

        <div
          class="row rule-select"
          :class="{ selected: ruleset === 'PFRPG' }"
          @click="set('PFRPG')"
        >
          <div class="col-2 initials">
            <h2 class="pf">PF</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Pathfinder</h2>
          </div>
        </div>

        <div
          class="row rule-select"
          :class="{ selected: ruleset === 'PFRPG2' }"
          @click="set('PFRPG2')"
        >
          <div class="col-2 initials">
            <h2 class="pt">P2</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Pathfinder 2</h2>
          </div>
        </div>

        <div v-if="gratisRulesets.includes('PF Playtest') || isAdmin"
          class="row rule-select"
          :class="{ selected: ruleset === 'PF Playtest' }"
          @click="set('PF Playtest')"
        >
          <div class="col-2 initials">
            <h2 class="pt">PT</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Pathfinder Playtest</h2>
          </div>
        </div>

        <div
          class="row rule-select"
          :class="{ selected: ruleset === 'Savage Worlds' }"
          @click="set('Savage Worlds')"
        >
          <div class="col-2 initials">
            <h2 class="sw">SW</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Savage Worlds</h2>
          </div>
        </div>

        <div v-if="gratisRulesets.includes('Savage Embers') || isAdmin"
          class="row rule-select"
          :class="{ selected: ruleset === 'Savage Embers' }"
          @click="set('Savage Embers')"
        >
          <div class="col-2 initials">
            <h2 class="se">SE</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Savage Embers</h2>
          </div>
        </div>

        <div v-if="gratisRulesets.includes('Embers RPG') || isAdmin"
          class="row rule-select"
          :class="{ selected: ruleset === 'Embers RPG' }"
          @click="set('Embers RPG')"
        >
          <div class="col-2 initials">
            <h2 class="em">EM</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Embers RPG</h2>
          </div>
        </div>

        <div v-if="gratisRulesets.includes('Solarian Conflict') || isAdmin"
          class="row rule-select"
          :class="{ selected: ruleset === 'Solarian Conflict' }"
          @click="set('Solarian Conflict')"
        >
          <div class="col-2 initials">
            <h2 class="sc">SC</h2>
          </div>
          <div class="col-10 description text-left">
            <h2>Solarian Conflict</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "ruleset",
  computed: {
    ...mapState({
      user: (state) => state.session.user,
      ruleset: (state) => state.session.user.settings.ruleset,
    }),
    ...mapGetters({
      isAdmin: "isAdmin",
    }),
    gratisRulesets() {
      let arr = [];
      if (this.user.gratis && this.user.gratis.rulesets)
        arr = this.user.gratis.rulesets;
      return arr;
    },
  },
  methods: {
    ...mapActions({
      updateSettings: "updateSettings",
      charactersAll: "characters/all",
      itemsAll: "items/all",
      rulesAll: "rules/all",
      spellsAll: "spells/all",
    }),
    async set(ruleset) {
      let payload = this.user.settings;
      payload.ruleset = ruleset;

      await this.updateSettings(payload);
      let p1 = this.charactersAll({ params: `ruleset=${ruleset}&sort=name` });
      let p2 = this.itemsAll({ params: `ruleset=${ruleset}&sort=name` });
      let p3 = this.rulesAll({ params: `ruleset=${ruleset}&sort=name` });
      let p4 = this.spellsAll({ params: `ruleset=${ruleset}&sort=name` });

      await Promise.all([p1, p2, p3, p4]);

      if (this.ruleset) {
        try {
          let path = this.$store.state.session.redirectUrl
            ? this.$store.state.session.redirectUrl
            : "/home";
          this.$store.commit("REDIRECT_SET", { redirectUrl: null });
          this.$router.push({ path: path });
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/_global";
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-bottom: 0;
}
.rule-select {
  cursor: pointer;
  margin-bottom: 1em;
  border: 2px solid $gray-500;
  .initials {
    color: white;
    background-color: $gray-500;
  }
  .description {
    color: $gray-500;
  }
  &:hover,
  &.selected {
    border: 2px solid $gray-900;
    background-color: $gray-500;
    .initials {
      background-color: $gray-900;
    }
    .description {
      color: $gray-900;
    }
    .dd {
      color: red;
    }
    .pf {
      color: tan;
    }
    .pt {
      color: orange;
    }
    .sc {
      color: blue;
    }
    .se {
      color: #ff5800;
    }
    .sw {
      color: gold;
    }
    .em {
      color: #ff5800;
    }
  }
}
</style>
